// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SPl0","selected":"styles_selected__1_2kn"};